module.exports = __webpack_public_path__ + "img/balance_bg.61eaf700.png";